import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import DtoPutOrderPoolContainerTrailer_StopAddress_Address from "./DtoPutOrderPoolContainerTrailer_StopAddress_Address";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutOrderPoolContainerTrailer_StopAddress extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.StopAddresses = [];
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 经停地址
     */
    StopAddresses?: DtoPutOrderPoolContainerTrailer_StopAddress_Address[];
}

/**
 * -表单校验
 */
export const DtoPutOrderPoolContainerTrailer_StopAddressRules = {
}

/**
 * -设置项
 */
export const DtoPutOrderPoolContainerTrailer_StopAddressMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "StopAddresses",
    Label: "经停地址",
    Customize: true,
  },
]
